import axios from "axios";
import {
  UserStore,
  GlobalStore,
  // CardsStore,
  // WalletStore,
  // StakesStore,
} from "stores";
import {
  notVerifiedMessage,
  twoFAMessage,
  // newPassRequired,
} from "helpers/consts";
import { token } from "./auth";
// import { flattenObject } from "helpers/funcs";
import type {
  UserInterface,
  UserLevelFlow,
  // TelegramWebAppData
} from "helpers/types";
import type {
  // RegisterCredentials,
  LoginCredentials,
  // VerifyEmailCredentials,
  ChangePasswordCredentials,
  JuniorPersonalData,
  ReferralResponse,
  // Add2FaVerificationResponse,
  // ChangePasswordReq,
  ChangePhoneNumberReq,
  ReferralLink,
  TelegramAuthCredentials,
  UserLevelsInfoRes,
  UserPersonalData,
} from "./types/user";

// export const register = async (credentials: RegisterCredentials) => {
//   GlobalStore.startLoading();

//   const registerCredentials: RegisterCredentials = {
//     ...credentials,
//     source: "FNT",
//   };

//   return axios
//     .post("/user/register", registerCredentials)
//     .then(({ data }) => {
//       if (data.token) {
//         localStorage.setItem("accessToken", data.token);
//       }
//       return true;
//     })
//     .catch((err) => {
//       if (err?.response?.data?.message) {
//         GlobalStore.setError(err.response.data.message);
//       }
//     })
//     .finally(() => GlobalStore.endLoading());
// };

// export const logIn = async (credentials: LoginCredentials) => {
//   GlobalStore.startLoading();
//   return axios
//     .post("/user/login", credentials)
//     .then(({ data }) => {
//       if (data?.emailVerified === false) {
//         GlobalStore.setError("email not verified");
//         return notVerifiedMessage;
//       }
//       token.set(data.token);
//       UserStore.setAuthenticated();
//     })
//     .catch((err) => {
//       if (err?.response?.data?.message === twoFAMessage) {
//         return twoFAMessage;
//       }
//       if (err?.response?.data?.message) {
//         GlobalStore.setError(err.response.data.message);
//       }
//       if (err?.response?.data?.message === newPassRequired) {
//         return newPassRequired;
//       }
//     })
//     .finally(() => GlobalStore.endLoading());
// };

export const getIsLogged = async (type?: "adminRedirect") => {
  GlobalStore.startLoading();
  return axios
    .get("/user/me")
    .then(({ data }) => {
      if (data?.emailVerified === false) {
        if (type === "adminRedirect") {
          GlobalStore.setError("User email is not verified");
          localStorage.removeItem("isLoggedAsAdmin");
        }
        return null;
      }
      if (type === "adminRedirect") {
        localStorage.setItem("loggedAsAdmin", "true");
      }
      UserStore.setAuthenticated();
      return true;
    })
    .catch(() => {
      if (type === "adminRedirect") {
        localStorage.removeItem("isLoggedAsAdmin");
        GlobalStore.setError("Incorrect admin token");
      }
      return null;
    })
    .finally(() => GlobalStore.endLoading());
};

// export const checkIsLogged = async (type?: "adminRedirect") => {
//   GlobalStore.startLoading();

//   const userToken = localStorage.getItem("accessToken");
//   axios.defaults.headers.common.Authorization = `Bearer ${userToken}`;

//   return axios
//     .get("/user/me")
//     .then(({ data }) => {
//       if (data?.emailVerified === false) {
//         if (type === "adminRedirect") {
//           GlobalStore.setError("User email is not verified");
//           localStorage.removeItem("isLoggedAsAdmin");
//         }
//         return null;
//       }
//       if (type === "adminRedirect") {
//         localStorage.setItem("loggedAsAdmin", "true");
//       }
//       UserStore.setStatistics(null);
//       UserStore.setRequestedForms(null);
//       UserStore.setFeesAndLimits(null);
//       CardsStore.clearCardsStore();
//       StakesStore.setActiveStakes(null);
//       WalletStore.setWalletsList(null);
//       UserStore.setAuthenticated();
//       return true;
//     })
//     .catch(() => {
//       if (type === "adminRedirect") {
//         localStorage.removeItem("isLoggedAsAdmin");
//         GlobalStore.setError("Incorrect admin token");
//       }
//       UserStore.logOut();
//       return null;
//     })
//     .finally(() => {
//       GlobalStore.endLoading();
//       localStorage.removeItem("companyAccess");
//     });
// };

// export const initiateVerifyEmail = async (
//   credentials: VerifyEmailCredentials
// ) => axios.post("/user/verify/email", credentials);

// export const resetPassword = async (credentials: VerifyEmailCredentials) =>
//   axios.post("/user/password/reset", credentials);

export const getIdentifyUser = async () => axios.get("/user/verify/identity");

// TODO remove after add auth stepers
export const changePasswordAfterReset = async ({
  resetCode,
  password,
}: ChangePasswordCredentials) =>
  axios.post(`/user/password/reset/${resetCode}`, { password });

// TODO ask about onsite junior verify
// not available now
export const updateJuniorPersonalData = async (data: JuniorPersonalData) =>
  axios.post(`/user/personal-data`, data);

// TODO no referrals now
export const getRefferals = async () =>
  axios.get<ReferralResponse>("/user/referrals");
export const getRefferalLinks = async () =>
  axios.get<ReferralLink[]>("/user/referral-links");

export const getFeesAndLimits = async () =>
  axios
    .get("/user/fees-and-limits")
    .then(({ data }) => {
      UserStore.setFeesAndLimits(data);
    })
    .catch(() => null);

export const getUserStatistics = async () =>
  axios
    .get("/user/statistics")
    .then(({ data }) => {
      UserStore.setStatistics(data);
    })
    .catch(() => null);

export const getUserPersonalData = async () =>
  axios.get<UserPersonalData>("/user/personal-data");

// export const changePassword = async (data: ChangePasswordReq) =>
//   axios.put("/user/change-password", data);

// TODO in future
export const changePhoneNumber = async (data: ChangePhoneNumberReq) =>
  axios.put("/user/change-phone-number", data);

export const telegramAuth = async (
  telegramUserData: string,
  credentials: TelegramAuthCredentials
) => {
  GlobalStore.startLoading();

  const telegramAuthCredentials: TelegramAuthCredentials = {
    ...credentials,
    source: "FNT",
  };

  return axios
    .post<UserInterface>(
      `/user/telegram-login?${telegramUserData}`,
      telegramAuthCredentials
    )
    .then(({ data }) => {
      token.set(data.token);
      UserStore.setAuthenticated();
      UserStore.setIsLoggedFromTelegram();
      localStorage.setItem("loggedFromTelegram", "true");
      if (window.Telegram?.WebApp) {
        const webApp = window.Telegram.WebApp;
        webApp.expand();
      }
    })
    .catch((err) => {
      if (err?.response?.data?.message) {
        UserStore.setTelegramLoginError(err.response.data.message);
      }
      UserStore.openTelegramLoginErrorModal();
    })
    .finally(() => GlobalStore.endLoading());
};

// TODO ask about telegram link
// in future
export const telegramLinkAccount = async (credentials: LoginCredentials) => {
  GlobalStore.startLoading();
  return axios
    .post("/user/link-account", credentials)
    .then(({ data }) => {
      if (data?.emailVerified === false) {
        GlobalStore.setError("email not verified");
        return notVerifiedMessage;
      }
      token.set(data.token);
      UserStore.setAuthenticated();
      return "success";
    })
    .catch((err) => {
      if (err?.response?.data?.message === twoFAMessage) {
        return twoFAMessage;
      }
      if (err?.response?.data?.message) {
        GlobalStore.setError(err.response.data.message);
      }
    })
    .finally(() => GlobalStore.endLoading());
};

// TODO no UserLevelsInfo now
export const getUserLevelsInfo = async () =>
  axios.get<UserLevelsInfoRes>("/user/level/list");

// TODO no UserLevelFlowStatus now
export const getUserLevelFlowStatus = async () =>
  axios
    .get<UserLevelFlow>("/user/level-flow-status")
    .then(({ data }) => {
      UserStore.setUserLevelFlowInfo(data);
      return data;
    })
    .catch((err) => {
      if (err?.response?.data?.message) {
        GlobalStore.setError(err.response.data.message);
      }
    });

// TODO no requestSeniorForms now
export const requestSeniorForms = async () =>
  axios.post("/user/request-senior-forms");
